import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal"
import documentModel from "@/models/document/document"
import router from "@/router"
import store from "@/store"
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable"
import usePagination from "@/views/components/pagination/usePagination"
import { onBeforeMount, reactive, ref, watch } from "@vue/composition-api"

export default function useLuckyWinnerWinnerList() {
  // const { fetchDocumentContainerList } = documentModel()

  const { pagination, onPageChange, onFilterEntity } = usePagination()
  const {
    filters,
    ordering,
  } = useFilterHeaderTable()

  const {
    openDefaultErrorModal,
    openWarningModal,
    openSuccessModal,
  } = useValidationModal()

  const loading = reactive({
    tableData: false,
  })

  const campaignId = ref(null)
  const roundId = ref(null)

  const fields = [
    { key: "seq", label: "No" },
    { key: "name", label: "Name" },
    { key: "mobile_no", label: "Mobile No" },
    { key: "gender", label: "Gender" },
    { key: "email", label: "Email" },
    { key: "announcement_date", label: "Announcement Date" },
  ]

  const winnerListTable = reactive({
    payload: [],
  })

  const fetchLuckyWinnerWinnerList = () => {
    winnerListTable.payload = [
      {
        seq: 1,
        name: "A A",
        mobile_no: "0812345678",
        gender: "ชาย",
        email: "a@a.a",
        announcement_date: "01-02-2022 00:00:00",
        status: 1,
        _showDetails: false,
      },
    ]
    pagination.rows = 1
    pagination.totalRows = 1
  }

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchLuckyWinnerWinnerList()
      }
    },
    { deep: true }
  )

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1

      fetchLuckyWinnerWinnerList()
    },
    { deep: true }
  )

  onBeforeMount(() => {
    campaignId.value = router.currentRoute.params.campaignId
    roundId.value = router.currentRoute.params.roundId

    fetchLuckyWinnerWinnerList()
  })

  return {
    campaignId,
    roundId,
    fields,
    loading,
    winnerListTable,
    pagination,
    onPageChange,
    onFilterEntity,
  }
}
